import { render, staticRenderFns } from "./Inversiones.vue?vue&type=template&id=2a3e48d1"
import script from "./Inversiones.vue?vue&type=script&lang=js"
export * from "./Inversiones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports